import $ from 'jquery'
import _ from 'lodash'
// import Promise from 'bluebird'
import anime from 'animejs'
import Parsley from 'parsleyjs'
import 'parsleyjs/dist/i18n/ja'
import 'parsleyjs/dist/i18n/ja.extra'
import 'parsleyjs/src/parsley.css'
/** pretty-checkbox */
import 'pretty-checkbox/src/pretty-checkbox.scss'
// import flatpickr from 'flatpickr'
// import 'flatpickr/dist/themes/material_red.css'
import Moment from 'moment'
import {extendMoment} from 'moment-range'
import Pikaday from 'pikaday'
import 'pikaday/scss/pikaday.scss'

import {observe, runInAction, autorun, isArrayLike, toJS} from 'mobx'
import EventEmitter from 'wolfy87-eventemitter'

import {
	eventStop,
	Ajax,
	TXT,
	getGlobal,
	nvl,
	diff,
	QueryString,
	registToGlobal,
	toInt,
	scrollElem,
	range as Range,
	deepMerge,
	actionGuard,
	urlInfo,
	deepUnset,
	invoke,
	ScrollLock,
} from 'eyes-lib/src/libs'
import '../../css/customize.scss'

import {App, SearchDomState, SearchMenuOption, SearchState} from './store'
import * as ShareFunc from './sharefunc'

import {Behavior, InputError, PNotify} from './behavior'

const moment = extendMoment(Moment)
const {fetchItem, fx} = ShareFunc

const event = new EventEmitter()

/** 検索メニューイベント */
const EVENTS = Object.freeze({
	/** 検索ボタン実行 */
	SEARCH: 'sMenu:search',
	/** 検索準備完了 */
	READY: 'sMenu:ready',
	/** マスターデータ準備完了 */
	MASTER_READY: 'sMenu:ready_master',
	/** ホテルデータ準備完了 */
	HOTEL_READY: 'sMenu:ready_hotel',
	/** URL変更イベント */
	URL_CHANGE: 'sMenu:change_url',
	/** メニュー初期化イベント */
	INIT: 'sMenu:init',
	/** 確認画面表示イベント */
	CONFIRM: Behavior.PNotify.EVENTS.CONFIRM,
})

/** セッションストレージ用検索パラメータ格納キー */
const KEYS = Object.freeze({
	/** 検索状態オブジェクト用 */
	SEARCH_STATE: 'search:state',
	/** 検索URL用 */
	SEARCH_URL: 'search:url',
})

/** アラートオプション */
const AlertOptions = Object.assign({}, Behavior.PNotify.v4.AlertOptions)

/** API基本パス */
let API_PATH = ``

/** 検索基本パス */
let SEARCH_PATH = ``

/**
 * 事業所コード
 * @type {string}
 */
let BRANCHGCD = null

/** @type {SearchParamKeys} */
let ParamKey = _.get(getGlobal(), 'SearchParamKeys', {})

/** @type {MSearchMenu.Items} */
const SearchMaster = _.get(getGlobal(), 'SearchMaster', {})

/** 差分抽出で利用するデフォルトパラメータオブジェクト */
let defParam = convertToParam(SearchState.new())

/** @type {Pikaday} 出発日ピッカー */
let depDatePicker = null

/**
 * mobx.runInAction + 連打防止
 * @param {string} label
 * @param {(evt?:Event|JQuery.Event, label?:String, options?:any) => any} func 連打防止させる関数
 * @param {{wait?:number, stop?:boolean}} [options]
 *  - wait: 連打無効ms
 *  - stop: イベント伝播停止フラグ
 */
const runInActionGuard = function (label, func, options) {
	return actionGuard((evt) => {
		runInAction(label, func.bind(null, evt, label, options))
	}, options)
}

/**
 * @param {string} label
 * @param {Function} func
 */
const fireAction = function (label, func) {
	autorun(
		(re) => {
			console.log(`[mobx.autorun]:`, label)
			re.trace()
			func()
		},
		{name: label},
	)
}

/** 利用するDOMを定義(キャッシュ化) */
const $dom = (() => {
	const $window = $(window)
	const $menu = $('.SearchArea')

	return {
		window: $window,
		form: $('form.SearchMenu'),
		menu: $menu.eq(0),
		/** 検索ボタン */
		searchBtn: $('.SubmitBox button[type="submit"]', $menu.eq(0)),
		/** リセットボタン */
		resetBtn: $('.ResetBox button[type="reset"]', $menu.eq(0)),
		/** 検索ワード */
		keyword: $('.FreeWord input[name="KEYWORD"]', $menu.eq(0)),
		/** 出発日 */
		depdate: {
			year: $('#year,#depyear', $menu.eq(0)).eq(0),
			month: $('#month,#depmonth', $menu.eq(0)).eq(0),
			day: $('#day,#depday', $menu.eq(0)).eq(0),
			/** pikaday用日付ピッカー要素。この要素がない場合はjQuery-UI datepickerが作動する */
			picker: $('#depdate-picker', $menu.eq(0)),
		},
		/** 出発地 */
		dep: {
			dep1: $('.Dep .CustomSelect .areaL', $menu.eq(0)),
			dep2: $('.Dep .CustomSelect .areaM', $menu.eq(0)),

			dep3: $('.Dep', $menu.eq(1)).eq(0).find('.CustomSelect .areaL'),
			dep4: $('.Dep', $menu.eq(1)).eq(0).find('.CustomSelect .areaM'),

			dep5: $('.Dep', $menu.eq(1)).eq(1).find('.CustomSelect .areaL'),
			dep6: $('.Dep', $menu.eq(1)).eq(1).find('.CustomSelect .areaM'),

			add1: $('.Dep .AddDepBox .Specified ol').eq(0),
			add2: $('.Dep .AddDepBox .Specified ol').eq(1),

			openBtn: $('.Dep .AddDepOpen', $menu.eq(0)),
			applyBtn: $('.AddDepArea .BtnBox .Specify'),
			closeBtn: $('.AddDepArea .BtnBox .Close'),
			modal: $('.AddDepArea').eq(0),
		},
		/** 目的地 方面 */
		homen: {
			homen1: $('.Des .CustomSelect .areaL', $menu.eq(0)),
			homen2: $('.Des .CustomSelect .areaM', $menu.eq(0)),
			homen3: $('.Des .CustomSelect .areaS', $menu.eq(0)),

			homen4: $('.Des', $menu.eq(2)).eq(0).find('.CustomSelect .areaL'),
			homen5: $('.Des', $menu.eq(2)).eq(0).find('.CustomSelect .areaM'),
			homen6: $('.Des', $menu.eq(2)).eq(0).find('.CustomSelect .areaS'),

			homen7: $('.Des', $menu.eq(2)).eq(1).find('.CustomSelect .areaL'),
			homen8: $('.Des', $menu.eq(2)).eq(1).find('.CustomSelect .areaM'),
			homen9: $('.Des', $menu.eq(2)).eq(1).find('.CustomSelect .areaS'),

			add1: $('.Des .AddDesBox .Specified ol').eq(0),
			add2: $('.Des .AddDesBox .Specified ol').eq(1),

			radio: $('input[name="condition"]', $menu),
			homenOr: $('.Des .AddDesBox .DesCondition input[value=""]'),
			homenAnd: $('.Des .AddDesBox .DesCondition input[value="1"]'),

			openBtn: $('.Des .AddDesOpen', $menu.eq(0)),
			applyBtn: $('.AddDesArea .BtnBox .Specify'),
			closeBtn: $('.AddDesArea .BtnBox .Close'),
			modal: $('.AddDesArea').eq(0),
		},
		/** 旅行期間 */
		term: $('.TravelTerm select', $menu),
		/** 利用人数 */
		pax: $('.TravelPax select', $menu),
		/** 予算 */
		price: {
			min: $('.TravelBudget .Lower select', $menu),
			max: $('.TravelBudget .Max select', $menu),
		},
		/** 添乗員 */
		tc: $('.TourConductor select', $menu),
		/** 交通機関 */
		transfer: {
			enableList: $('.Transportation .AddTransBox', $menu.eq(0)),
			listArea: $('.AddTransArea .Transportation div').eq(0),
			openBtn: $('.Transportation .AddTransOpen', $menu.eq(0)),
			applyBtn: $('.AddTransArea .BtnBox .Specify'),
			closeBtn: $('.AddTransArea .BtnBox .Close'),
			modal: $('.AddTransArea').eq(0),
		},
		/** こだわり条件 */
		choice: {
			enableList: $('.DetailedItem .AddItemBox', $menu.eq(0)),
			openBtn: $('.DetailedItem .AddItemOpen', $menu.eq(0)),
			listArea: $('.AddItemArea .DetailedItem div').eq(0),
			applyBtn: $('.AddItemArea .BtnBox .Specify'),
			closeBtn: $('.AddItemArea .BtnBox .Close'),
			modal: $('.AddItemArea').eq(0),
		},
		/** 宿泊施設 */
		hotel: {
			enableList: $('.DetailedHotel .AddHotelBox', $menu.eq(0)),
			openBtn: $('.DetailedHotel .AddHotelOpen', $menu.eq(0)),
			listArea: $('.AddHotelArea .DetailedHotel div').eq(0),
			applyBtn: $('.AddHotelArea .BtnBox .Specify'),
			closeBtn: $('.AddHotelArea .BtnBox .Close'),
			modal: $('.AddHotelArea').eq(0),
		},
	}
})()

/**
 * モーダル画面のリサイズ処理
 * @description タイミングは素数がいいかも
 */
const resizeModal = _.debounce(
	/**
	 * @param {JQuery} $target
	 */
	($target) => {
		if (!$target || $target.length === 0) return //!EXIT
		const css = getCenterStyle($target)

		anime(
			_.merge(css, {
				targets: $target.get(0),
				duration: 211,
				easing: 'easeOutQuint',
			}),
		)
	},
	/** 素数 */ 59,
)

/**
 * 対象jQueryオブジェクトが画面中央となるスタイルを取得
 * @param {JQuery} $target
 */
function getCenterStyle($target) {
	if (!$target || $target.length === 0) return {} //!EXIT

	const $window = $dom.window
	const w = $window.width()
	const h = $window.height()
	const cw = $target.outerWidth()
	const ch = $target.outerHeight()
	return {
		left: `${Math.max(w - cw, 4) / 2}px`,
		top: `${Math.max(h - ch, 60) / 2}px`,
	}
}

/**
 * モーダルウインドウ管理
 * @description モーダル機能はイベント駆動の散らかった設計になりがちなので、
 * 処理の流れがわかりやすいようにまとめた。
 * @example
 * ModalQueue.regist(Element).open()
 * @example // 2画面遷移するモーダル画面
 * ModalQueue.regist(Element1).regist(Element2).open()
 */
class ModalQueue {
	/**
	 * @type {{$modal: JQuery<HTMLElement>, show: ($modal: any, $modalBg: any) => Promise<void>,close: ($modal: any, $modalBg: any) => Promise<any>, hide: ($modal: any, $modalBg: any) => Promise<void>}[] }
	 */
	static queue = []

	/**
	 * モーダルアクション
	 */
	static async show($modal) {
		/** Modalクラス付与 */
		$modal.addClass('Modal')

		/** 中央配置スタイルを適応しておく（アニメーションの始点設定） */
		$modal.css(getCenterStyle($modal))

		/**
		 * フェードイン
		 * @type {HTMLElement[]}
		 */

		await anime({
			targets: $modal.get(0),
			duration: 600,
			easing: 'easeInOutCubic',
			opacity: [0, 1],
			begin: () => {
				$modal.css({display: 'block'})
			},
		}).finished
	}

	/**
	 * Close待ち
	 * @description Closeされるまでresolveしない(閉じられるまで待つ)
	 */
	static close($modal, $modalBg) {
		return new Promise((resolve) => {
			function onCloseClick(evt) {
				eventStop(evt)

				/** イベント掃除 */
				$('.ModalQueue-seal-close').off('click', onCloseClick)

				return resolve(evt)
			}

			$('.ModalQueue-seal-close').on('click', onCloseClick)
		})
	}

	/** モーダルアクション */
	static async hide($modal) {
		/** モーダル背景 */
		await anime({
			targets: $modal.get(0),
			duration: 400,
			easing: 'easeInOutCubic',
			opacity: [1, 0],
			complete: () => {
				$modal.css({display: 'none'})
			},
		}).finished
	}

	/**
	 * モーダル画面登録
	 * @description regist後、openで登録したmodal画面を呼び出していく
	 * @param {JQuery[]} $modal
	 */
	static regist(...$modal) {
		_.chain($modal)
			.castArray()
			.each(($modal) =>
				ModalQueue.config.modalClassName.forEach((className) => {
					$modal.addClass(className)
				}),
			)
			.each(($modal) =>
				ModalQueue.config.closeClassName.forEach((className) => {
					$(`.${className}`, $modal).addClass('ModalQueue-seal-close')
				}),
			)
			.map(($modal) => {
				return {$modal}
			})
			.each((item) => {
				//@ts-ignore
				ModalQueue.queue.push(item)
			})
			.commit()

		return ModalQueue
	}

	/**
	 * @typedef {{closeClassName:string[],modalClassName:string[],bgClassName:string[]}} ModalQueueConfig
	 * @type {ModalQueueConfig}
	 */
	static config = {
		closeClassName: [],
		modalClassName: ['ModalQueue-seal-modal'],
		bgClassName: ['ModalQueue-seal-overlay'],
	}

	/**
	 * モーダル画面の閉じる機能を割り当てるクラス名を登録
	 */
	static configure = _.once(
		/**
		 * @param  {ModalQueueConfig} options
		 */
		(options) => {
			ModalQueue.config = deepMerge(ModalQueue.config, options)
		},
	)

	/**
	 * モーダル画面表示実行
	 * @description regist後、openで登録したmodal画面を呼び出していく
	 */
	static async open() {
		/** モーダル背景をDOMに挿入 */
		const $modalBg = $(`<div class="ModalQueue-seal-close ${ModalQueue.config.bgClassName.join(' ')}"></div>`)
		$('body').append($modalBg)

		/** awaitさせずに並行処理させる */
		anime({
			targets: $modalBg.get(0),
			duration: 400,
			easing: 'easeInOutCubic',
			opacity: [0, 1],
			begin: () => {
				$modalBg.css({display: 'block'})
			},
		})

		while (true) {
			const {$modal} = ModalQueue.queue[0]

			/** イベント掃除できるように関数定義 */
			function resizeMyModal() {
				resizeModal($modal)
			}

			/** リサイズイベント登録 */
			$dom.window.on('resize', resizeMyModal).trigger('resize')

			/** スクロールロック */
			ScrollLock.on()

			/** モーダル表示 */
			await ModalQueue.show($modal)

			/** closeイベント待ち */
			await ModalQueue.close($modal, $modalBg)

			/** キュー削除 */
			ModalQueue.queue.shift()

			/** リサイズイベント解除 */
			$dom.window.off('resize', resizeMyModal)

			/** キューがなくなればbleak処理 */
			if (ModalQueue.queue.length === 0) {
				/** モーダル背景削除 */
				const hideBg = anime({
					targets: $modalBg.get(0),
					duration: 400,
					easing: 'easeInOutCubic',
					opacity: [1, 0],
				}).finished

				/** モーダル非表示 */
				const hideModal = ModalQueue.hide($modal)

				await Promise.all([hideBg, hideModal])

				$modalBg.remove()

				/** スクロールロック解除 */
				ScrollLock.off()

				break //! EXIT
			}

			/** モーダル非表示 */
			await ModalQueue.hide($modal)
		}
	}
}

/***************************************************************
 * 検索状態オブジェクトから検索URLを作成する
 * @param {SearchState} state
 **************************************************************/
function createSearchURL(state, branchgcd = BRANCHGCD) {

	if ( App.data.headercd )
		state.header_cd = App.data.headercd

	/** 状態オブジェクトからURLパラメータ用オブジェクトに変換 */
	const paramData = convertToParam(state)
	// console.log('SearchDomState', SearchDomState)
	// console.log('@@@',state)
	// console.log('@@@',paramData)

	/** デフォルト値との差分だけ抽出 */
	const diffData = diff(defParam, paramData)
	// console.log('@@@', {state, defParam, paramData})
	// console.log('@@@', {diffData})
	const queryParam = QueryString.stringify(diffData)
	const pathURL = `${SEARCH_PATH}/${branchgcd}?${queryParam}`
	return pathURL
}

/***************************************************************
 * 検索条件ステータスを検索APIパラメータに変換する
 * @param {Partial<SearchState | SearchMenuOption>} state
 **************************************************************/
function convertToParam(state) {
	return _.reduce(
		state,
		(acc, val, statusKey) => {
			const pkey = _.get(ParamKey, statusKey.toUpperCase())
			if (pkey) {
				/** フリーワードパラメータは空白 */
				if ( 'w' === pkey && _.isString(val) ) {
					val = val.replace(/[\s　]/g, `,`).split(`,`)
				}

				if (isArrayLike(val)) {
					_.set(acc, pkey, val.slice())
				} else {
					_.set(acc, pkey, val || '')
				}
			}
			return acc
		},
		{},
	)
}

/***************************************************************
 * 検索APIパラメータを検索条件ステータスに変換する
 * @param {Object.<string,any>} state
 * @returns {SearchState}
 **************************************************************/
function convertToState(state) {
	const ParamKeyInvert = _.invert(ParamKey)

	//@ts-ignore
	return _.reduce(
		state,
		(acc, val, pkey) => {
			const statusKey = _.chain(ParamKeyInvert).get(pkey, '').value().toLowerCase()
			if (statusKey) {
				/** 数値型にしておきたいプロパティ */
				if (statusKey == 'page' || statusKey == 'size') _.set(acc, statusKey, toInt(val))
				else _.set(acc, statusKey, val)
			}
			return acc
		},
		{},
	)
}

/**
 * 検索メニューパラメータのバリデーション
 * @param {Object.<string, string|number|boolean>} params
 */
function validSearchMenuParams(params) {
	if (_.isEmpty(_.get(params, 'dg'))) console.warn('出発地グループコード(dg)が設定されていません。')
	if (_.isEmpty(_.get(params, 'hg'))) console.warn('目的地グループコード(hg)が設定されていません。')
	if (_.isEmpty(_.get(params, 'cg'))) console.warn('だわり条件グループコード(cg)が設定されていません。')
	if (_.isEmpty(_.get(params, 'tg'))) console.warn('交通グループコード(tg)が設定されていません。')
	if (_.isEmpty(_.get(params, 'mg'))) console.warn('旅行期間グループコード(mg)が設定されていません。')
	if (_.isEmpty(_.get(params, 'yg'))) console.warn('予算グループコード(yg)が設定されていません。')
	if (_.isEmpty(_.get(params, 'pg'))) console.warn('利用人数グループコード(pg)が設定されていません。')
}

/**
 * 検索パラメータのバリデーション
 * @param {SearchState} myState
 */
function validSearchParams(myState) {
	if (_.isEmpty(_.get(myState, 'header_cd'))) console.warn('ヘッダフッタコード(hcd)が設定されていません。')
	if (!_.isEmpty(_.get(myState, 'agent')) && _.isEmpty(_.get(myState, 'pamphletcd'))) {
		console.warn(`代理店コード(agent)が設定されていますが、パンフレットコード(pa)が設定されていません。`)
	}
}

/**
 * チェックボックスのON/OFFを制御
 * @param {JQuery<HTMLElement>|HTMLElement} $area
 * @param {string|string[]} value
 */
function applyCheckboxState($area, value) {
	//console.log($area, `${value}`)
	$(`input[type="checkbox"]`, $area).prop('checked', false)

	/** 値を配列化 */
	const values = isArrayLike(value) ? value.slice() : [value]
	_.chain(values)
		.compact()
		.each((val) => {
			/** 対象DOMを取得 */
			const $elem = $(`input[type="checkbox"][value="${val}"]`, $area)
			/** 値を制御 */
			$(`input[type="checkbox"][value="${val}"]`, $area).prop('checked', true)
		})
		.commit()
}

/**
 * こだわり条件の有効リスト適用(レンダリング)
 * @see applyMenuTransferState
 * @param {string|string[]} value1
 * @param {string|string[]} value2
 */
function applyMenuChoiceState(value1, value2) {
	const blockTag = TXT`<div class="Specified on"></div>`
	const itemTag = TXT`<dl>
						|	<dt></dt>
						|	<dd><span class="ClearIcon"></span></dd>
						|</dl>
						|`

	/** 子だけ有効な親リストを取得する */
	const values1 = _.compact(isArrayLike(value1) ? value1.slice() : [value1])
	/** 値を配列化 */
	const values2 = _.compact(isArrayLike(value2) ? value2.slice() : [value2])

	/** 子だけ有効な親リストを取得する */
	const disableValues = _.chain(SearchMaster.choice)
		.filter((item) => _.includes(values2, item.choice2))
		/** 親コード取得 */
		.map((item) => item.choice1)
		/** 重複削除 */
		.uniq()
		/** 有効な親との差分を取得 */
		.difference(values1)
		.value()

	/** 親項目 */
	const $group = _.chain(values1)
		.concat(disableValues)
		.map((val) => _.find(SearchMaster.choice, {choice1: val}))
		.sortBy(['sort1'])
		.reverse() //prependで追加するので逆順にしておく
		// .tap( console.info.bind(null, '###有効なこだわり条件') )
		/** いったん要素クリア */
		.tap(() => $dom.choice.enableList.find('.Specified').remove())
		.map((item) => {
			/** 親だけのElementを登録 */
			const $block = $(blockTag)
			const $item = $(itemTag)
			const groupCode = item.choice1

			$block.data('group-code', groupCode)
			/** 有効な項目名をセット */
			$('dt', $item).text(item.choice1name)
			$item.addClass('GroupHead')

			/** 子要素だけ有効な親リストに含まれているならば */
			if (_.includes(disableValues, groupCode)) {
				/** NoCheckクラス付与 */
				$item.addClass('NoCheck')
			} else {
				/** 削除ボタン設定 */
				const $clear = $item.find('.ClearIcon')
				$clear.data('code', groupCode)

				/** 削除イベントを仕込む */
				$clear.on('click', async (evt) => {
					/** 削除用コードを取り出す */
					const $clear = $(evt.currentTarget)
					const code = $clear.data('code')
					const $target = $clear.closest('dl')
					await anime({
						targets: $target.get(0),
						opacity: [1, 0],
						duration: 220,
					}).finished
					// await Velocity.animate($target.get(0), {opacity: 0}, {duration: 220})

					/** valuesから削除コードを削除する */
					_.remove(values1, (val) => val == code)

					/** 状態反映 */
					runInAction('こだわり条件グループ削除ボタン', () => {
						SearchDomState.choice_group = values1
					})
				})
			}

			return $block.append($item)
		})
		.each(($block) => $dom.choice.enableList.prepend($block))
		.value()

	/** 子となる項目を組み立てる */
	_.chain(values2)
		.map((val) => _.find(SearchMaster.choice, {choice2: val}))
		.filter((val) => !_.isEmpty(val))
		.sortBy(['sort2'])
		// .tap( console.info.bind(null, '###有効なこだわり条件(子)') )
		.each((item) => {
			const $item = $(itemTag)
			/** 有効な項目名をセット */
			$('dt', $item).text(item.choice2name)

			/** 削除ボタン設定 */
			const $clear = $item.find('.ClearIcon')
			$clear.data('code', item.choice2)

			/** 削除イベントを仕込む */
			$clear.on('click', async (evt) => {
				/** 削除用コードを取り出す */
				const $clear = $(evt.currentTarget)
				const code = $clear.data('code')
				const $target = $clear.closest('dl')
				await anime({
					targets: $target.get(0),
					opacity: [1, 0],
					duration: 220,
				}).finished
				// await Velocity.animate($target.get(0), {opacity: 0}, {duration: 220})

				/** valuesから削除コードを削除する */
				_.remove(values2, (val) => val == code)
				/** 状態反映 */
				runInAction('こだわり条件削除ボタン', () => {
					SearchDomState.choice = values2
				})
			})
			/** 差し込む要素を特定する */
			const groupCode = item.choice1
			const $parent = _.find($group, ($block) => $block.data('group-code') == groupCode)
			$parent.append($item)
		})
		.commit()

	/** 有効値があるならAfterSelectクラス付与 */
	if (_.isEmpty(SearchDomState.choice) && _.isEmpty(SearchDomState.choice_group))
		$dom.choice.enableList.removeClass('AfterSelect')
	else $dom.choice.enableList.addClass('AfterSelect')
}

/**
 * 交通機関の有効リスト適用(レンダリング)
 * @param {string|string[]} _transfer
 * @param {string|string[]} _transport
 */
function applyMenuTransferState(_transfer, _transport) {
	const blockTag = TXT`<div class="Specified on"></div>`
	const itemTag = TXT`<dl>
						|	<dt></dt>
						|	<dd><span class="ClearIcon"></span></dd>
						|</dl>
						|`

	/** 値を配列化 */
	const values1 = _.compact(isArrayLike(_transfer) ? _transfer.slice() : [_transfer])
	const values2 = _.compact(isArrayLike(_transport) ? _transport.slice() : [_transport])
	// console.info( '手段', values1, 'キャリア', values2 )

	/** 子だけ有効な親リストを取得する */
	const disableValues = _.chain(SearchMaster.transfer)
		.filter((item) => _.includes(values2, item.transfer2))
		/** 親コード取得 */
		.map((item) => item.transfer1)
		/** 重複削除 */
		.uniq()
		/** 有効な親との差分を取得 */
		.difference(values1)
		.value()

	/** 親項目(交通手段) */
	const $group = _.chain(values1)
		.concat(disableValues)
		.map((val) => _.find(SearchMaster.transfer, {transfer1: val}))
		.compact()
		.sortBy(['sort1'])
		.reverse() //prependで追加するので逆順にしておく
		// .tap( console.info.bind(null, '###有効な交通機関') )
		// .tap( console.info )
		/** いったん要素クリア */
		.tap(() => $dom.transfer.enableList.find('.Specified').remove())
		.map((item) => {
			/** 親だけのElementを登録 */
			const $block = $(blockTag)
			const $item = $(itemTag)
			const groupCode = item.transfer1

			$block.data('group-code', groupCode)
			/** 有効な項目名をセット */
			$('dt', $item).text(item.transfer1name)
			$item.addClass('GroupHead')

			/** 子要素だけ有効な親リストに含まれているならば */
			if (_.includes(disableValues, groupCode)) {
				/** NoCheckクラス付与 */
				$item.addClass('NoCheck')
			}

			/** 削除ボタン設定 */
			const $clear = $item.find('.ClearIcon')
			$clear.data('code', groupCode)

			/** 削除イベントを仕込む */
			$clear.on('click', async (evt) => {
				/** 削除用コードを取り出す */
				const $clear = $(evt.currentTarget)
				const code = $clear.data('code')
				const $target = $clear.closest('dl')

				await anime({
					targets: $target.get(0),
					opacity: [1, 0],
					duration: 220,
				}).finished
				// await Velocity.animate($target.get(0), {opacity: 0}, {duration: 220})

				/** valuesから削除コードを削除する */
				_.remove(values1, (val) => val == code)
				/** 状態反映 */
				runInAction('交通機関(手段)削除ボタン', () => {
					SearchDomState.transfer = values1
				})
			})

			return $block.append($item)
		})
		.each(($block) => $dom.transfer.enableList.prepend($block))
		.value()

	/** 子となる項目を組み立てる */
	_.chain(values2)
		.map((val) => _.find(SearchMaster.transfer, {transfer2: val}))
		// .tap( console.log )
		.each((item) => {
			const $item = $(itemTag)
			/** 有効な項目名をセット */
			$('dt', $item).text(item.transfer2name)

			/** 削除ボタン設定 */
			const $clear = $item.find('.ClearIcon')
			$clear.data('code', item.transfer2)

			/** 削除イベントを仕込む */
			$clear.on('click', async (evt) => {
				/** 削除用コードを取り出す */
				const $clear = $(evt.currentTarget)
				const code = $clear.data('code')
				const $target = $clear.closest('dl')

				await anime({
					targets: $target.get(0),
					opacity: [1, 0],
					duration: 220,
				}).finished
				// await Velocity.animate($target.get(0), {opacity: 0}, {duration: 220})

				/** valuesから削除コードを削除する */
				_.remove(values2, (val) => val == code)
				/** 状態反映 */
				runInAction('交通機関(キャリア)削除ボタン', () => {
					SearchDomState.transport = values2
				})
			})
			/** 差し込む要素を特定する */
			const groupCode = item.transfer1
			const $parent = _.find($group, ($block) => $block.data('group-code') == groupCode)
			$parent.append($item)
		})
		.commit()

	/** 有効値があるならAfterSelectクラス付与 */
	if (_.isEmpty(SearchDomState.transfer) && _.isEmpty(SearchDomState.transport))
		$dom.transfer.enableList.removeClass('AfterSelect')
	else $dom.transfer.enableList.addClass('AfterSelect')
}

/**
 * 宿泊施設の有効リスト適用(レンダリング)
 * @see applyMenuTransferState
 * @description 親コードは都市コード
 * @param {string|string[]} value1
 * @param {string|string[]} value2
 */
function applyMenuHotelState(value1, value2) {
	const blockTag = TXT`<div class="Specified on"></div>`
	const itemTag = TXT`<dl>
						|	<dt></dt>
						|	<dd><span class="ClearIcon"></span></dd>
						|</dl>
						|`

	/** 親の値を配列化 */
	const values1 = _.compact(isArrayLike(value1) ? value1.slice() : [value1])
	/** 値を配列化 */
	const values2 = _.compact(isArrayLike(value2) ? value2.slice() : [value2])

	/** 子だけ有効な親リストを取得する */
	const disableValues = _.chain(SearchMaster.hotel)
		.filter((item) => _.includes(values2, item.code))
		/** 親コード取得 */
		.map((item) => item.toshi_code)
		/** 重複削除 */
		.uniq()
		/** 有効な親との差分を取得 */
		.difference(values1)
		.value()

	/** 親項目 */
	const $group = _.chain(values1)
		.concat(disableValues)
		.map((val) => _.find(SearchMaster.hotel, {toshi_code: val}))
		// .tap( console.info.bind(null, '###有効な宿泊施設1') )
		.compact()
		.sortBy(['sort1', 'sort2', 'sort3'])
		.reverse() //prependで追加するので逆順にしておく
		// .tap( console.info.bind(null, '###有効な宿泊施設') )
		/** いったん要素クリア */
		.tap(() => $dom.hotel.enableList.find('.Specified').remove())
		.map((item) => {
			/** 親だけのElementを登録 */
			const $block = $(blockTag)
			const $item = $(itemTag)
			const groupCode = item.toshi_code

			$block.data('group-code', groupCode)
			/** 有効な項目名をセット */
			$('dt', $item).text(nvl(item.toshi_name2, item.toshi_name))
			$item.addClass('GroupHead')

			/** 子要素だけ有効な親リストに含まれているならば */
			if (_.includes(disableValues, groupCode)) {
				/** NoCheckクラス付与 */
				$item.addClass('NoCheck')
			} else {
				/** 削除ボタン設定 */
				const $clear = $item.find('.ClearIcon')
				$clear.data('code', groupCode)

				/** 削除イベントを仕込む */
				$clear.on('click', async (evt) => {
					/** 削除用コードを取り出す */
					const $clear = $(evt.currentTarget)
					const code = $clear.data('code')
					const $target = $clear.closest('dl')

					await anime({
						targets: $target.get(0),
						opacity: [1, 0],
						duration: 220,
					}).finished
					// await Velocity.animate($target.get(0), {opacity: 0}, {duration: 220})

					/** valuesから削除コードを削除する */
					_.remove(values1, (val) => val == code)

					/** 状態反映 */
					runInAction('こだわり条件グループ削除ボタン', () => {
						SearchDomState.hotel_group = values1
					})
				})
			}

			return $block.append($item)
		})
		.each(($block) => $dom.hotel.enableList.prepend($block))
		.value()

	/** 子となる項目を組み立てる */
	_.chain(values2)
		.map((val) => _.find(SearchMaster.hotel, {code: val}))
		.compact()
		.sortBy(['sort1', 'sort2', 'sort3'])
		// .tap( console.info.bind(null, '###有効な宿泊施設(子)') )
		.each((item) => {
			const $item = $(itemTag)
			/** 有効な項目名をセット */
			$('dt', $item).text(nvl(item.name2, item.name))

			/** 削除ボタン設定 */
			const $clear = $item.find('.ClearIcon')
			$clear.data('code', item.code)

			/** 削除イベントを仕込む */
			$clear.on('click', async (evt) => {
				/** 削除用コードを取り出す */
				const $clear = $(evt.currentTarget)
				const code = $clear.data('code')
				const $target = $clear.closest('dl')

				await anime({
					targets: $target.get(0),
					opacity: [1, 0],
					duration: 220,
				}).finished
				// await Velocity.animate($target.get(0), {opacity: 0}, {duration: 220})

				/** valuesから削除コードを削除する */
				_.remove(values2, (val) => val == code)
				/** 状態反映 */
				runInAction('こだわり条件削除ボタン', () => {
					SearchDomState.hotel = values2
				})
			})
			/** 差し込む要素を特定する */
			const groupCode = item.toshi_code

			/** 親項目のDOMに追加していく */
			// console.log($group)
			const $parent = _.find($group, ($block) => $block.data('group-code') == groupCode)
			if ($parent) $parent.append($item)
		})
		.commit()

	/** 有効値があるならAfterSelectクラス付与 */
	if (_.isEmpty(SearchDomState.hotel) && _.isEmpty(SearchDomState.hotel_group))
		$dom.hotel.enableList.removeClass('AfterSelect')
	else $dom.hotel.enableList.addClass('AfterSelect')
}

/**
 * エリア大分類UIアクション
 * @param {import('mobx').IObjectDidChange} change
 * @param {JQuery<HTMLElement>} $target
 * @param {string} keyname
 */
function area1MenuAction(change, $target, keyname) {
	if (change.type != 'update') return //!EXIT
	/** @type {AreaType2[]} */
	const newValue = change.newValue
	const selected = _.get(change.object, keyname)

	/** 指定なし以外は削除 */
	$target.children(':gt(0)').remove()

	_.chain(newValue)
		/** displayフラグでフィルタリング */
		.filter('display')
		.each((val) => {
			const $option = $(document.createElement('option'))
			$option.val(val.code)
			$option.text(val.name)
			if (selected == val.code) $option.prop('selected', true)
			$target.append($option)
		})
		.commit()
}

/**
 * エリア中分類UIアクション
 * @param {import('mobx').IObjectDidChange} change
 * @param {string} keyname
 * @param {string} parentKey
 * @param {JQuery<HTMLElement>} $target
 */
function area2MenuAction(change, $target, keyname, parentKey) {
	// console.info('area2MenuAction', change)
	if (change.type != 'update') return //!EXIT
	/** @type {AreaType2[]} */
	const newValue = change.newValue
	const selected = _.get(change.object, keyname)
	const parent = _.get(change.object, parentKey)

	/** 指定なし以外は削除 */
	$target.children(':gt(0)').remove()
	_.chain(newValue)
		/** 親の値でフィルタリング */
		.filter((val) => val.parent == parent)
		// .tap(console.log)
		.each((val) => {
			const $option = $(document.createElement('option'))
			$option.val(val.code)
			$option.text(val.name)
			$option.data('parent', val.parent)
			if (selected == val.code) $option.prop('selected', true)
			$target.append($option)
		})
		.commit()
}

/**
 * エリア小分類UIアクション
 * @param {import('mobx').IObjectDidChange} change
 * @param {JQuery<HTMLElement>} $target
 * @param {string} keyname
 * @param {string} parentKey
 * @param {string} rootKey
 */
function area3MenuAction(change, $target, keyname, parentKey, rootKey) {
	if (change.type != 'update') return //!EXIT
	/** @type {AreaType3[]} */
	const newValue = change.newValue
	const selected = _.get(change.object, keyname)
	const parent = _.get(change.object, parentKey)
	const root = _.get(change.object, rootKey)

	/** 指定なし以外は削除 */
	$target.children(':gt(0)').remove()
	_.chain(newValue)
		/** 親の値でフィルタリング */
		.filter((val) => val.parent == parent && val.root == root)
		.each((val) => {
			const $option = $(document.createElement('option'))
			$option.val(val.code)
			$option.text(val.name)
			$option.data('parent', val.parent)
			$option.data('root', val.root)
			if (selected == val.code) $option.prop('selected', true)
			$target.append($option)
		})
		.commit()
}

/**
 * エリアメニュー用リストデータの選別
 * @template {AreaType1|AreaType2|AreaType3} T
 * @param {T[]} areaMenuItems
 * @param {string} parentValue
 * @returns {T[]}
 */
function changeAreaMenu(areaMenuItems, parentValue) {
	return _.map(areaMenuItems, (item) => {
		const val = _.get(item, 'parent', '')
		/** 選択値がある場合、親要素と同じ値のものだけ表示、選択値がない場合はtrueで表示 */
		item.display = parentValue ? val == parentValue : true
		return item
	})
}

/***************************************************************
 * 都市コードからホテルリストを取得、画面反映
 * @description 選択都市がコロコロ変えられると、
 * ただの遅延実行では順番が保証されないため、
 * PromiseQueueに投げる
 * //しかし、現在は`宿泊施設オープンイベント`で処理するようにしているため、
 * //PromiseQueueの必要性はほぼないが、PromiseQueueを外す理由も特にない
 **************************************************************/
const addQueueToshiHotel = _.debounce(
	/** @param {Partial<SearchState>} homenState */
	function _fetchToshiHotel(homenState) {
		/** 状態オブジェクトからURLパラメータ用オブジェクトに変換 */
		const paramData = convertToParam(homenState)
		const diffData = diff(defParam, paramData)

		/** クエリパラメータ作成 */
		const paramQuery = QueryString.stringify(diffData)

		/** ホテル選択リストエリアをクリア */
		$dom.hotel.listArea.empty()

		const loadingOpt = {
			target: $dom.hotel.listArea.parent(),
		}

		/** 一連の流れをまとめたPromiseを作成 */
		const p = Promise.resolve()
			.then(() => fx.loadingStart(loadingOpt))
			.then(() =>
				Ajax.load({
					url: `${API_PATH}/v1/master/toshihotel?${paramQuery}`,
					method: `GET`,
					dataType: 'json',
				}),
			)
			.then(fetchItem)
			.then(async (items) => {
				/** SearchMasterにマージ */
				_.set(SearchMaster, 'hotel', items)
				event.emit(EVENTS.HOTEL_READY)
				await fx.loadingEnd(loadingOpt)
				return items
			})
			.catch(async (err) => {
				//_.defer( ()=>{throw err} )
				_.set(SearchMaster, 'hotel', [])
				event.emit(EVENTS.HOTEL_READY)
				await fx.loadingEnd(loadingOpt)
			})
			.then(drawHotelSelectUI)
			.then((obj) => {
				/** ホテルリストを取り出す、undefinedならば空データとして処理 */
				const data = _.get(obj, 'data', [])
				if (data) {
					/** 現在リストアップされているホテルコードリストを取得 */
					const masterHotelCodes = _.map(SearchMaster.hotel, (item) => item.code)

					/** 適用中のホテルコードリストを取得 */
					const applyHotelCodes = _.castArray(SearchDomState.hotel.slice())

					/** 適用中のホテルコードリストから削除となるホテルコードを差分抽出 */
					const delList = _.difference(applyHotelCodes, masterHotelCodes)

					runInAction('addQueueToshiHotelからのホテル更新', () => {
						/** 削除実行 */
						SearchDomState.hotel = _.without(applyHotelCodes, ...delList)
					})
				}
				return obj
			})

		/** Queueに貯める（順次実行） */
		//@ts-ignore
		App.queue.add(() => p)
	},
	41,
)

/**
 * ホテル選択一覧画面構築
 * @description `pretty-checkbox`の力を借ります
 * @param {MSearchMenu.HotelType[]} data
 */
function drawHotelSelectUI(data) {
	const baseTag = TXT`<dl>
						|	<dt>
						|		<label></label>
						|	</dt>
						|	<dd>
						|		<ul></ul>
						|	</dd>
						|</dl>
						|`

	const listTag = TXT`<li>
						|	<span class="CustomCheckobx pretty p-default">
						|		<input type="checkbox" id="" value="">
						|		<label for=""></label>
						|	</span>
						|</li>
						|`

	const $doms = _.chain(data)
		.groupBy((item) => `${item.toshi_code}`)
		// .sortBy( group => `${_.head(group).sort1}_${_.head(group).sort2}` )
		.tap(() => $dom.hotel.listArea.empty())
		.map((group, toshiCode) => {
			return _(group)
				.chain()
				.orderBy('code')
				.reduce(($baseTag, item, idx) => {
					/** 先頭データは方面ラベル */
					if (idx === 0) {
						const id = `searchmenu_hotel_${toshiCode}`
						$('dt label', $baseTag).attr('id', id).data('code', toshiCode).text(item.toshi_name)
					}
					/** キャリア設定 */
					{
						const id = `searchmenu_hotel_${toshiCode}_${idx}`
						const $listTag = $(listTag)
						$('input[type="checkbox"]', $listTag)
							.attr('id', id)
							.val(item.code)
							.next('label')
							.attr('for', id)
							.text(item.name)

						/** 追加 */
						$baseTag.find('dd>ul').append($listTag)
					}

					return $baseTag
				}, $(baseTag))
				.value()
		})
		.each(($dl) => {
			$dom.hotel.listArea.append($dl)
		})
		//.tap( console.warn.bind('◆') )
		.tap(($dlList) => {
			/** チェック済みアイテムの対応 交通手段 */
			applyCheckboxState($dom.hotel.listArea.find('dd'), SearchDomState.hotel)
		})
		// .each( $dl =>{
		// 	/** 親となるとチェックボックスの状態を見て、子のチェックボックスを制御 */
		// 	modalCheckboxStateAction( $dl )
		// } )
		.value()

	return {
		data: data,
		$doms: $doms,
	}
}

/**
 * 追加出発地・目的地の描画
 * @param {MSearchMenu.Dep[]|MSearchMenu.Homen[]} areaList
 * @param {JQuery<HTMLElement>} $target
 * @param {string} key1
 * @param {string} key2
 * @param {string} [key3]
 */
function updateAddArea(areaList, $target, key1, key2, key3) {
	/** いったん削除 */
	$target.empty()

	const closeTag = `<li class="Btn"><span class="ClearIcon"></span></li>`

	const add1 = _.chain(areaList)
		.find((area) => _.get(area, 'area1') == _.get(SearchDomState, key1))
		.get('area1name')
		.value()

	const add2 = _.chain(areaList)
		.find((area) => _.get(area, 'area2') == _.get(SearchDomState, key2))
		.get('area2name')
		.value()

	const add3 = _.chain(areaList)
		.find((area) => _.get(area, 'area3') == _.get(SearchDomState, key3))
		.get('area3name')
		.value()

	_.chain([add1, add2, add3])
		.compact()
		.map((text) => {
			const liElem = document.createElement('li')
			liElem.innerText = text
			return liElem
		})
		.each((elem) => {
			$target.append(elem)
		})
		.tap((elem) => {
			/** リストがあるならば削除ボタンも挿入 */
			if (_.size(elem) > 0) {
				const $close = $(closeTag)
				$target.append($close)
				$close.on(
					'click',
					runInActionGuard('追加出発地の削除1', () => {
						_.chain([key1, key2, key3])
							.compact()
							.each((key) => {
								_.set(SearchDomState, key, '')
							})
							.commit()
					}),
				)
			}
		})
		.value()
}

/**
 * 日付バリデーション設定を更新
 * @param {Partial<{year:number, month:number, day:number}>} args
 */
function updateDateValidation({year, month, day}) {
	/** 月、日設定があれば */
	if (day > 0 || month > 0) {
		/** 年と月は必須に設定 */
		$dom.depdate.year.prop('required', true)
		$dom.depdate.month.prop('required', true)
	} else {
		/** 年が設定されていれば */
		if (year > 0) {
			/** 月必須 */
			$dom.depdate.year.prop('required', true)
			$dom.depdate.month.prop('required', true)
		} else {
			$dom.depdate.year.removeAttr('required')
			$dom.depdate.month.removeAttr('required')
		}
	}
}

/**
 * 予算バリデーション設定を更新
 * @param {{min:number,max:number}} args
 */
function updatePriceValidation({min, max}) {
	if (min > 0) {
		$dom.price.max.attr('min', min)
	} else {
		$dom.price.min.removeAttr('min')
		$dom.price.max.removeAttr('min')
	}

	if (max > 0) {
		$dom.price.min.attr('max', max)
	} else {
		$dom.price.min.removeAttr('max')
		$dom.price.max.removeAttr('max')
	}
}

/** 検索バリデーション実行 */
function formValidation() {
	return invoke(_.get(App, 'data.form'), 'validate')
}

/***************************************************************
 * 変更検出パターンと実行アクションが定義されたリスト
 * @type {Action[]}
 **************************************************************/
const BaseActions = [
	/** paxMenu 変更時 */
	{
		pattern: {name: 'paxMenu', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT

			/** @type {SearchState} */
			const obj = change.object
			const $target = $dom.pax
			const selected = change.object.roompax

			/** 指定なし以外は削除 */
			$target.children(':gt(0)').remove()
			_.each(change.newValue, (val) => {
				const $option = $(document.createElement('option'))
				$option.val(val.value)
				$option.text(val.name)
				if (selected == val.value) $option.prop('selected', true)
				$target.append($option)
			})
		},
	},
	/** termMenu 変更時 */
	{
		pattern: {name: 'termMenu', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			/** @type {SearchState} */
			const obj = change.object
			const $target = $dom.term
			const selected = obj.term

			/** 指定なし以外は削除 */
			$target.children(':gt(0)').remove()
			_.each(change.newValue, (val) => {
				const $option = $(document.createElement('option'))
				$option.val(val.value)
				$option.text(val.name)
				if (selected == val.value) $option.prop('selected', true)
				$target.append($option)
			})
		},
	},
	/** minpriceMenu 変更時 */
	{
		pattern: {name: 'minpriceMenu', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT

			/** @type {SearchState} */
			const obj = change.object
			const $target = $dom.price.min
			const selected = obj.minprice
			/** 指定なし以外は削除 */
			$target.children(':gt(0)').remove()
			_.each(change.newValue, (val) => {
				const $option = $(document.createElement('option'))
				$option.val(val.value)
				$option.text(val.name)
				if (selected == val.value) $option.prop('selected', true)
				$target.append($option)
			})
		},
	},
	/** maxpriceMenu 変更時 */
	{
		pattern: {name: 'maxpriceMenu', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			/** @type {SearchDomState['maxpriceMenu']} */
			const newValue = change.newValue

			/** @type {SearchState} */
			const obj = change.object

			const $target = $dom.price.max
			const selected = obj.maxprice

			/** 指定なし以外は削除 */
			$target.children(':gt(0)').remove()
			_.each(newValue, (val) => {
				const $option = $(document.createElement('option'))
				$option.val(val.value)
				$option.text(val.name)
				if (selected == val.value) $option.prop('selected', true)
				$target.append($option)
			})
		},
	},

	/** transfer 変更時 */
	{
		pattern: {name: 'transfer', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT

			/** @type {SearchState} */
			const obj = change.object

			/** 交通手段はdtタグ */
			applyCheckboxState($dom.transfer.listArea.find('dt'), change.newValue)
		},
	},
	/** transport 変更時 */
	{
		pattern: {name: 'transport', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT

			/** @type {SearchState} */
			const obj = change.object

			/** 運輸キャリアはddタグ */
			applyCheckboxState($dom.transfer.listArea.find('dd'), change.newValue)
		},
	},
	/** choice 変更時 */
	{
		pattern: {name: 'choice', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT

			/** チェックボックスを有効にする */
			applyCheckboxState($dom.choice.listArea, change.newValue)
		},
	},

	/** hotel 変更時 */
	{
		pattern: {name: 'hotel', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT

			/** チェックボックスを有効にする */
			applyCheckboxState($dom.hotel.listArea, change.newValue)
		},
	},

	/** dep_yymm 変更時 */
	{
		pattern: {name: 'dep_yymm', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT

			/** @type {string} */
			const newValue = change.newValue

			/** 6桁チェック */
			if (_.size(newValue) == 6) {
				$dom.depdate.year.val(newValue.substr(0, 4))
				$dom.depdate.month.val(newValue.substr(4, 2))
			}
		},
	},

	/** dep_dd 変更時 */
	{
		pattern: {name: 'dep_dd', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			/** @type {string} */
			const newValue = change.newValue
			/** 桁チェック */
			if (_.size(newValue) < 3) {
				$dom.depdate.day.val(newValue.padStart(2, '0'))
			}
		},
	},
	/** homen_and 変更時 */
	{
		pattern: {name: 'homen_and', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT

			/** radio状態を変更するついでに、ラベルのActiveクラスを制御 */
			if ('1' == change.newValue) {
				$dom.homen.homenOr.prop('checked', false).closest('label').removeClass('Active')
				$dom.homen.homenAnd.prop('checked', true).closest('label').addClass('Active')
			} else {
				$dom.homen.homenOr.prop('checked', true).closest('label').addClass('Active')
				$dom.homen.homenAnd.prop('checked', false).closest('label').removeClass('Active')
			}
		},
	},
	/** tcflag 変更時 */
	{
		pattern: {name: 'tcflag', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			$dom.tc.val(change.newValue)
		},
	},
	/** roompax 変更時 */
	{
		pattern: {name: 'roompax', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			$dom.pax.val(change.newValue)
		},
	},
	/** term 変更時 */
	{
		pattern: {name: 'term', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			$dom.term.val(change.newValue)
		},
	},
	/** minprice 変更時 */
	{
		pattern: {name: 'minprice', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			$dom.price.min.val(change.newValue)
		},
	},
	/** maxprice 変更時 */
	{
		pattern: {name: 'maxprice', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			$dom.price.max.val(change.newValue)
		},
	},
	/** searchkeyword 変更時 */
	{
		pattern: {name: 'searchkeyword', type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT
			const value = _( `${change.newValue}`.replace(/,/g, ` `) )
				.chain()
				.split(` `)
				.compact()
				.join(` `)
				.value()
			$dom.keyword.val( value )
		},
	},
]

/***************************************************************
 * 出発地アクション 1-2 を 3セット
 * @type {Action[]}
 **************************************************************/
const depMenuActions = [
	/** dep1Menu 変更時 */
	{
		pattern: {name: `dep1Menu`, type: 'update'},
		action: (change) => area1MenuAction(change, $dom.dep.dep1, 'dep1'),
	},
	/** dep2Menu 変更時 */
	{
		pattern: {name: `dep2Menu`, type: 'update'},
		action: (change) => area2MenuAction(change, $dom.dep.dep2, 'dep2', 'dep1'),
	},
	/** dep3Menu 変更時 */
	{
		pattern: {name: `dep3Menu`, type: 'update'},
		action: (change) => area1MenuAction(change, $dom.dep.dep3, 'tmp_dep3'),
	},
	/** dep4Menu 変更時 */
	{
		pattern: {name: `dep4Menu`, type: 'update'},
		action: (change) => area2MenuAction(change, $dom.dep.dep4, 'tmp_dep4', 'tmp_dep3'),
	},
	/** dep5Menu 変更時 */
	{
		pattern: {name: `dep5Menu`, type: 'update'},
		action: (change) => area1MenuAction(change, $dom.dep.dep5, 'tmp_dep5'),
	},
	/** dep6Menu 変更時 */
	{
		pattern: {name: `dep6Menu`, type: 'update'},
		action: (change) => area2MenuAction(change, $dom.dep.dep6, 'tmp_dep6', 'tmp_dep5'),
	},

	/** dep3 変更時 */
	{
		pattern: {name: `dep3`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.dep, $dom.dep.add1, 'dep3', 'dep4'),
	},
	/** dep4 変更時 */
	{
		pattern: {name: `dep4`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.dep, $dom.dep.add1, 'dep3', 'dep4'),
	},
	/** dep5 変更時 */
	{
		pattern: {name: `dep5`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.dep, $dom.dep.add2, 'dep5', 'dep6'),
	},
	/** dep6 変更時 */
	{
		pattern: {name: `dep6`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.dep, $dom.dep.add2, 'dep5', 'dep6'),
	},
]

const depMenuLazyActions = [
	/** tmp_dep3 変更時 */
	{
		pattern: {name: `tmp_dep3`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.tmp_dep4 = ''
			}
		},
	},
	/** tmp_dep5 変更時 */
	{
		pattern: {name: `tmp_dep5`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.tmp_dep6 = ''
			}
		},
	},
	/** dep1 変更時 dep2をリセット */
	{
		pattern: {name: `dep1`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.dep2 = ''
			}
		},
	},
]

/***************************************************************
 * 目的地アクション 1-9
 * @type {Action[]}
 **************************************************************/
const homenMenuActions = [
	/** homen1Menu 変更時 */
	{
		pattern: {name: `homen1Menu`, type: 'update'},
		action: (change) => area1MenuAction(change, $dom.homen.homen1, 'homen1'),
	},
	/** homen2Menu 変更時 */
	{
		pattern: {name: `homen2Menu`, type: 'update'},
		action: (change) => area2MenuAction(change, $dom.homen.homen2, 'homen2', 'homen1'),
	},
	/** homen3Menu 変更時 */
	{
		pattern: {name: `homen3Menu`, type: 'update'},
		action: (change) => area3MenuAction(change, $dom.homen.homen3, 'homen3', 'homen2', 'homen1'),
	},
	/** homen4Menu 変更時 */
	{
		pattern: {name: `homen4Menu`, type: 'update'},
		action: (change) => area1MenuAction(change, $dom.homen.homen4, 'tmp_homen4'),
	},
	/** homen5Menu 変更時 */
	{
		pattern: {name: `homen5Menu`, type: 'update'},
		action: (change) => area2MenuAction(change, $dom.homen.homen5, 'tmp_homen5', 'tmp_homen4'),
	},
	/** homen6Menu 変更時 */
	{
		pattern: {name: `homen6Menu`, type: 'update'},
		action: (change) => area3MenuAction(change, $dom.homen.homen6, 'tmp_homen6', 'tmp_homen5', 'tmp_homen4'),
	},
	/** homen7Menu 変更時 */
	{
		pattern: {name: `homen7Menu`, type: 'update'},
		action: (change) => area1MenuAction(change, $dom.homen.homen7, 'tmp_homen7'),
	},
	/** homen8Menu 変更時 */
	{
		pattern: {name: `homen8Menu`, type: 'update'},
		action: (change) => area2MenuAction(change, $dom.homen.homen8, 'tmp_homen8', 'tmp_homen7'),
	},
	/** homen9Menu 変更時 */
	{
		pattern: {name: `homen9Menu`, type: 'update'},
		action: (change) => area3MenuAction(change, $dom.homen.homen9, 'tmp_homen9', 'tmp_homen8', 'tmp_homen7'),
	},
	/** homen4 変更時 追加出発地文言更新 */
	{
		pattern: {name: `homen4`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.homen, $dom.homen.add1, 'homen4', 'homen5', 'homen6'),
	},
	/** homen5 変更時 追加出発地文言更新 */
	{
		pattern: {name: `homen5`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.homen, $dom.homen.add1, 'homen4', 'homen5', 'homen6'),
	},
	/** homen6 変更時 追加出発地文言更新 */
	{
		pattern: {name: `homen6`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.homen, $dom.homen.add1, 'homen4', 'homen5', 'homen6'),
	},
	/** homen7 変更時 追加出発地文言更新 */
	{
		pattern: {name: `homen7`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.homen, $dom.homen.add2, 'homen7', 'homen8', 'homen9'),
	},
	/** homen8 変更時 追加出発地文言更新 */
	{
		pattern: {name: `homen8`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.homen, $dom.homen.add2, 'homen7', 'homen8', 'homen9'),
	},
	/** homen9 変更時 追加出発地文言更新 */
	{
		pattern: {name: `homen9`, type: 'update'},
		action: (change) => updateAddArea(SearchMaster.homen, $dom.homen.add2, 'homen7', 'homen8', 'homen9'),
	},
]

const homenMenuLazyActions = [
	/** homen1 変更時 */
	{
		pattern: {name: `homen1`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.homen2 = ''
				SearchDomState.homen3 = ''
			}
		},
	},
	/** homen2 変更時 */
	{
		pattern: {name: `homen2`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.homen3 = ''
			}
		},
	},
	/** tmp_homen4 変更時 */
	{
		pattern: {name: `tmp_homen4`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.tmp_homen5 = ''
				SearchDomState.tmp_homen6 = ''
			}
		},
	},
	/** tmp_homen5 変更時 */
	{
		pattern: {name: `tmp_homen5`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.tmp_homen6 = ''
			}
		},
	},
	// /** tmp_homen6 変更時 */
	// {
	// 	pattern: {name: `tmp_homen6`, type: 'update'},
	// 	action: change => area3Action( change, $dom.homen.homen6 ),
	// },
	/** tmp_homen7 変更時 */
	{
		pattern: {name: `tmp_homen7`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.tmp_homen8 = ''
				SearchDomState.tmp_homen9 = ''
			}
		},
	},
	/** tmp_homen8 変更時 */
	{
		pattern: {name: `tmp_homen8`, type: 'update'},
		action: (change) => {
			if (change.type != 'update') return //!EXIT]
			if (change.oldValue != change.newValue) {
				SearchDomState.tmp_homen9 = ''
			}
		},
	},
	// /** tmp_homen9 変更時 */
	// {
	// 	pattern: {name: `tmp_homen9`, type: 'update'},
	// 	action: change => area3Action( change, $dom.homen.homen9 ),
	// },
]

/** 結合させたアクション */
const ActionList = _.concat([], BaseActions, depMenuActions, homenMenuActions)

/**
 * 初期に必要な処理
 * @param {string} [api_path=API_PATH]
 */
async function boot(api_path = API_PATH) {
	/**
	 * SP 現在の検索条件
	 * @description 画面サイズが767以下
	 */
	if (!window.matchMedia('screen and (min-width:769px)').matches) {
		$(function () {
			$('.Side .SearchArea .Inner').hide()
			$('.SearchArea h2').on('click', function () {
				$(this).next().toggle()
			})
		})
	}

	/** 準備中を表現 */
	$dom.menu.css({opacity: 0.6})

	/** ParamKeyがなければapiで取得 */
	const keydata =
		_.size(ParamKey) > 0
			? ParamKey
			: await Ajax.load({
					url: `${api_path}/v1/master/paramkeys`,
					method: `GET`,
					dataType: 'json',
			  }).then(fetchItem)

	/** パラメーターのキーデータ定義 */
	_.merge(ParamKey, keydata)

	/** デフォルト値定義 */
	const def = convertToParam(SearchState.new())
	_.merge(defParam, def)

	/** モーダル画面の閉じる機能を割り当てるクラス名を登録 */
	ModalQueue.configure({
		closeClassName: ['Close', 'Specify'],
		modalClassName: ['Modal'],
		bgClassName: ['ModalBox'],
	})
	// _.set(getGlobal(), 'ModalQueue', ModalQueue)
}

/***************************************************************
 * 検索メニューの状態変化を管理
 * @param {string} branchgcd 事業所コード
 * @param {SearchMenuOption} [options] 検索メニュー制御オプション
 **************************************************************/
const searchMenu = async (branchgcd, options) => {
	/**
	 * 検索メニュー制御オプションを定義
	 * @description 初期値と引数のオプションをマージ
	 */
	const opt = _.merge(SearchMenuOption.new(), options)

	/** APIパス決定 */
	API_PATH = opt.API_PATH

	/** 検索パス設定 */
	SEARCH_PATH = opt.SEARCH_PATH

	/** 事業所コード設定 */
	BRANCHGCD = branchgcd

	/** 事業所コードを束縛させたcreateSearchURL */
	const createSearchURLBinded = _.bind(createSearchURL, null, _, branchgcd)

	/** バリデーションモジュールのオプション定義 */
	{
		/** 日本語設定 */
		Parsley.setLocale('ja')

		Parsley.on(
			'field:validated',
			/**
			 * フィールド単位でのvalidation後のParsleyフィールドイベント
			 * @param {parsley.Field} evt
			 */
			(evt) => {
				/** try-catchだとIE10が型判定できなかったので普通にif文で静的メソッドをコール */
				const hasError = _.size(evt.getErrorsMessages()) > 0
				if (hasError) InputError.enable(evt)
				else InputError.disable(evt)
			},
		)

		/** 検索ワード入力変更イベント */
		$dom.keyword.on('change', (evt) => {
			eventStop(evt)
			const val = $(evt.currentTarget).nvl()
			runInAction('検索ワード入力変更イベント', () => {
				SearchDomState.searchkeyword = val
			})
		})

		/** バリデーションモジュール適用 */
		App.data.form = $dom.form.parsley({
			/** トリガーイベント */
			trigger: 'keyup focusout change input',
			/** Key events threshold before validation */
			validationThreshold: 2,
			uiEnabled: false,
			focus: 'first',
			namespace: 'data-valid-',
			priorityEnabled: true,
		})
	}

	/************************** ↓↓↓↓↓↓↓↓↓↓ **************************/
	/************************** メイン処理 **************************/
	/************************** ↓↓↓↓↓↓↓↓↓↓ **************************/

	/** 検索に必要なマスターを取得 */
	Promise.resolve(API_PATH)
		.then(boot)
		.then(getMaster(opt))
		.then(setMaster)
		.then(setupMenuUI)
		.then(setupCalendarUI)
		.then((data) => {
			enableMenuUIAction()

			/** 出発地1-2の変更イベント登録 */
			_.each(Range(1, 2).toArray(), (id) => {
				_.get($dom, `dep.dep${id}`).on('change', (evt) => {
					runInAction('出発地UI操作', () => {
						/** DOMとstateの同期 */
						_.set(SearchDomState, `dep${id}`, $(evt.currentTarget).nvl())
					})
				})
			})

			/** 出発地3-6の変更イベント登録 */
			_.each(Range(3, 6).toArray(), (id) => {
				_.get($dom, `dep.dep${id}`).on('change', (evt) => {
					runInAction('出発地UI操作', () => {
						/** テンポラリ用の値を変更 */
						_.set(SearchDomState, `tmp_dep${id}`, $(evt.currentTarget).nvl())
					})
				})
			})

			/** 目的地1-3の変更イベント登録 */
			_.each(Range(1, 3).toArray(), (id) => {
				_.get($dom, `homen.homen${id}`).on('change', (evt) => {
					runInAction('目的地UI操作', () => {
						/** DOMとstateの同期 */
						_.set(SearchDomState, `homen${id}`, $(evt.currentTarget).nvl())
					})
				})
			})

			/** 目的地4-9の変更イベント登録 */
			_.each(Range(4, 9).toArray(), (id) => {
				_.get($dom, `homen.homen${id}`).on('change', (evt) => {
					runInAction('目的地UI操作', () => {
						/** テンポラリ用の値を変更 */
						_.set(SearchDomState, `tmp_homen${id}`, $(evt.currentTarget).nvl())
					})
				})
			})

			formValidation()
			return data
		})
		.then((data) => {
			$dom.menu.css({opacity: 1.0})

			/** 準備完了 */
			event.emit(EVENTS.READY)
		})

	/************************** ↓↓↓↓↓↓↓↓↓↓↓↓↓↓ **************************/
	/************************** mobxリスナ定義 **************************/
	/************************** ↓↓↓↓↓↓↓↓↓↓↓↓↓↓ **************************/

	/** パラメータ単位で状態変化があれば発火 */
	observe(SearchDomState, (change) => {
		console.log('[change]', change)

		/** 検索用パターンオブジェクトを定義 */
		const searchPattern = _.pick(change, ['type', 'name'])

		// console.info('searchPattern', searchPattern)
		// console.info({ActionList})

		/** マッチするパターンを探して実行 その時changeを渡す */
		_.chain(ActionList).find({pattern: searchPattern}).invoke('action', change).commit()
	})

	/** アクション・トランザクションで更新がかかったデータをまとめて処理する場合 */
	fireAction('交通機関変更イベント', () => {
		/** 検出したい状態変数を使わないと発火しないので使う */
		const transfer = SearchDomState.transfer
		const transport = SearchDomState.transport

		/** 有効リストをメニューに反映 */
		{
			_.has(SearchMaster, 'transfer')
				? /** マスターデータがあればそのままUIに反映 */
				  applyMenuTransferState(transfer, transport)
				: /** マスターデータ取得完了時にメニューに有効リストをUIに反映 */
				  event.once(EVENTS.MASTER_READY, () => applyMenuTransferState(transfer, transport))
		}
	})

	/** 変更を検出したい状態変数はドットアクセサで使わないと発火しないので注意 */
	fireAction('こだわり条件変更イベント', () => {
		const choiceGroup = SearchDomState.choice_group
		const choice = SearchDomState.choice

		/** 有効リストをメニューに反映 */
		{
			_.has(SearchMaster, 'choice')
				? /** マスターデータがあればそのままUIに反映 */
				  applyMenuChoiceState(choiceGroup, choice)
				: /** マスターデータ取得完了時にメニューに有効リストをUIに反映 */
				  event.once(EVENTS.MASTER_READY, () => applyMenuChoiceState(choiceGroup, choice))
		}
	})

	/** 変更を検出したい状態変数はドットアクセサで使わないと発火しないので注意 */
	fireAction('ホテル変更イベント', () => {
		/** ホテルグループは都市コードが入ってる。 */
		const hotelGroup = SearchDomState.hotel_group
		const hotel = SearchDomState.hotel

		/** 有効リストをメニューに反映 */
		{
			_.has(SearchMaster, 'hotel')
				? /** マスターデータがあればそのままUIに反映 */
				  applyMenuHotelState(hotelGroup, hotel)
				: /** マスターデータ取得完了時にメニューに有効リストをUIに反映 */
				  event.once(EVENTS.HOTEL_READY, () => applyMenuHotelState(hotelGroup, hotel))
		}
	})

	fireAction('出発地の値変更イベント', () => {
		const depData = {
			dep1: SearchDomState.dep1,
			dep2: SearchDomState.dep2,
			dep3: SearchDomState.dep3,
			dep4: SearchDomState.dep4,
			dep5: SearchDomState.dep5,
			dep6: SearchDomState.dep6,
		}

		/** セレクト状態にする */
		$dom.dep.dep1.val(depData.dep1)
		$dom.dep.dep2.val(depData.dep2)
		$dom.dep.dep3.val(depData.dep3)
		$dom.dep.dep4.val(depData.dep4)
		$dom.dep.dep5.val(depData.dep5)
		$dom.dep.dep6.val(depData.dep6)
	})

	fireAction('出発地メニュー変更イベント', () => {
		const depData = {
			dep1: SearchDomState.dep1,
			dep2: SearchDomState.dep2,
			dep3: SearchDomState.tmp_dep3,
			dep4: SearchDomState.tmp_dep4,
			dep5: SearchDomState.tmp_dep5,
			dep6: SearchDomState.tmp_dep6,
		}

		runInAction('セレクトメニュー構築', () => {
			SearchDomState.dep2Menu = changeAreaMenu(SearchDomState.dep2Menu.slice(), depData.dep1)
			SearchDomState.dep3Menu = changeAreaMenu(SearchDomState.dep3Menu.slice(), '')
			SearchDomState.dep4Menu = changeAreaMenu(SearchDomState.dep4Menu.slice(), depData.dep3)
			SearchDomState.dep5Menu = changeAreaMenu(SearchDomState.dep5Menu.slice(), '')
			SearchDomState.dep6Menu = changeAreaMenu(SearchDomState.dep6Menu.slice(), depData.dep5)
		})

		$dom.dep.dep3.val(depData.dep3)
		$dom.dep.dep4.val(depData.dep4)
		$dom.dep.dep5.val(depData.dep5)
		$dom.dep.dep6.val(depData.dep6)
	})

	fireAction('方面の値変更イベント', () => {
		const homenData = {
			homen1: SearchDomState.homen1,
			homen2: SearchDomState.homen2,
			homen3: SearchDomState.homen3,
			homen4: SearchDomState.homen4,
			homen5: SearchDomState.homen5,
			homen6: SearchDomState.homen6,
			homen7: SearchDomState.homen7,
			homen8: SearchDomState.homen8,
			homen9: SearchDomState.homen9,
			hmn_grp: SearchDomState.hmn_grp,
		}
		/** 宿泊施設の値設定 */
		addQueueToshiHotel(homenData)

		/** セレクト状態にする */
		$dom.homen.homen1.val(homenData.homen1)
		$dom.homen.homen2.val(homenData.homen2)
		$dom.homen.homen3.val(homenData.homen3)
		$dom.homen.homen4.val(homenData.homen4)
		$dom.homen.homen5.val(homenData.homen5)
		$dom.homen.homen6.val(homenData.homen6)
		$dom.homen.homen7.val(homenData.homen7)
		$dom.homen.homen8.val(homenData.homen8)
		$dom.homen.homen9.val(homenData.homen9)
	})

	fireAction('方面メニュー変更イベント', () => {
		const homenData = {
			homen1: SearchDomState.homen1,
			homen2: SearchDomState.homen2,
			homen3: SearchDomState.homen3,
			homen4: SearchDomState.tmp_homen4,
			homen5: SearchDomState.tmp_homen5,
			homen6: SearchDomState.tmp_homen6,
			homen7: SearchDomState.tmp_homen7,
			homen8: SearchDomState.tmp_homen8,
			homen9: SearchDomState.tmp_homen9,
		}
		runInAction('セレクトメニュー構築', () => {
			SearchDomState.homen2Menu = changeAreaMenu(SearchDomState.homen2Menu.slice(), homenData.homen1)
			SearchDomState.homen3Menu = changeAreaMenu(SearchDomState.homen3Menu.slice(), homenData.homen2)
			SearchDomState.homen4Menu = changeAreaMenu(SearchDomState.homen4Menu.slice(), '')
			SearchDomState.homen5Menu = changeAreaMenu(SearchDomState.homen5Menu.slice(), homenData.homen4)
			SearchDomState.homen6Menu = changeAreaMenu(SearchDomState.homen6Menu.slice(), homenData.homen5)
			SearchDomState.homen7Menu = changeAreaMenu(SearchDomState.homen7Menu.slice(), '')
			SearchDomState.homen8Menu = changeAreaMenu(SearchDomState.homen8Menu.slice(), homenData.homen7)
			SearchDomState.homen9Menu = changeAreaMenu(SearchDomState.homen9Menu.slice(), homenData.homen8)
		})
	})

	fireAction('出発日(年月)変更イベント', () => {
		const yymm = SearchDomState.dep_yymm

		/** 6桁数字ならば */
		if (/^[0-9]{6}/.test(yymm)) {
			/** 日付オブジェクトを用意 */
			const mo = moment(`${yymm}01`, 'YYYYMMDD')

			/** 有効年月ならば */
			if (mo.isValid()) {
				/** 先頭以外削除 */
				$dom.depdate.day.children(':gt(0)').remove()

				/** 月末日取得 */
				const lastDay = mo.daysInMonth()

				/** 選択値 */
				const selectDay = _.padStart(SearchDomState.dep_dd, 2, '0')

				_.each(Range(1, lastDay).toArray(), (day) => {
					const dd = _.padStart(day, 2, '0')
					const optionElem = document.createElement('option')
					optionElem.value = dd
					optionElem.text = `${dd}日`
					/** 選択値セット */
					if (dd == selectDay) optionElem.selected = true
					$dom.depdate.day.append(optionElem)
				})
			}
		}
	})

	fireAction('出発日変更イベント', () => {
		const depDate = {
			yymm: SearchDomState.dep_yymm,
			dd: SearchDomState.dep_dd,
		}

		const depInt = {
			year: toInt(_.padStart(depDate.yymm.substr(0, 4), 4, '0')),
			month: toInt(_.padStart(depDate.yymm.substr(4, 2), 2, '0')),
			day: toInt(depDate.dd),
		}

		/** ピッカーが設定されているならば */
		if (depDatePicker) {
			if (depDate.yymm && depDate.dd && '00' != depDate.dd) {
				const yymmdd = moment(`${depDate.yymm}${depDate.dd}`, 'YYYYMMDD')
				/** 第二引数 true: min-max制限しない false: min-max制限する */
				depDatePicker.setDate(yymmdd.format('YYYY-MM-DD'), true)
				depDatePicker.gotoDate(yymmdd.toDate())
			} else if (depDate.yymm) {
				depDatePicker.setDate(null)
				depDatePicker.gotoDate(new Date(depInt.year, depInt.month))
			} else {
				depDatePicker.setDate(null)
			}
		} else if ($('.Calender input').length > 0) {
			const yymmdd = moment(`${depDate.yymm}${depDate.dd}`, 'YYYYMMDD')
			$('.Calender input').datepicker('setDate', yymmdd.format('YYYY/MM/DD'))
		}

		updateDateValidation(depInt)
		formValidation()
	})

	fireAction('予算変更', () => {
		const {minprice, maxprice} = SearchDomState
		updatePriceValidation({min: toInt(minprice), max: toInt(maxprice)})
		formValidation()
	})

	/************************** ↓↓↓↓↓↓↓↓ **************************/
	/************************** 関数定義 **************************/
	/************************** ↓↓↓↓↓↓↓↓ **************************/

	/**
	 * 検索メニュー設定
	 * @param {MSearchMenu.Items} data
	 */
	function setupMenuUI(data) {
		/** 追加出発地 */
		// console.info(SearchDomState.dep3)
		// console.info(SearchDomState.dep5)
		// console.info(SearchDomState.homen4)
		// console.info(SearchDomState.homen7)

		updateAddArea(SearchMaster.dep, $dom.dep.add1, 'dep3', 'dep4')
		updateAddArea(SearchMaster.dep, $dom.dep.add2, 'dep5', 'dep6')
		updateAddArea(SearchMaster.homen, $dom.homen.add1, 'homen4', 'homen5', 'homen6')
		updateAddArea(SearchMaster.homen, $dom.homen.add2, 'homen7', 'homen8', 'homen9')

		return data
	}

	/**
	 * カレンダー、データピッカー設定
	 *
	 * @param {MSearchMenu.Items} data
	 */
	function setupCalendarUI(data) {
		/** 有効日付範囲 */
		const moRange = moment.rangeFromInterval('year', 2, new Date())
		const yearRange = Array.from(moRange.by('year')).map((m) => m.format('YYYY'))

		/** 出発日 年セレクタ設定 */
		if ($dom.depdate.year.children().length <= 1) {
			/** 選択値 */
			const selectVal = _.padStart(SearchDomState.dep_yymm.substr(0, 4), 4, '0')

			_.each(yearRange, (year) => {
				const yyyy = _.padStart(`${year}`, 4, '0')
				const optionElem = document.createElement('option')
				optionElem.value = yyyy
				optionElem.text = `${yyyy}年`
				/** 選択値セット */
				if (yyyy == selectVal) optionElem.selected = true
				$dom.depdate.year.append(optionElem)
			})
		}

		/** 出発日 月セレクタ設定 */
		if ($dom.depdate.month.children().length <= 1) {
			/** 選択値 */
			const selectVal = _.padStart(SearchDomState.dep_yymm.substr(4, 2), 2, '0')

			_.each(Range(1, 12).toArray(), (month) => {
				const mm = _.padStart(month, 2, '0')
				const optionElem = document.createElement('option')
				optionElem.value = mm
				optionElem.text = `${mm}月`
				/** 選択値セット */
				if (mm == selectVal) optionElem.selected = true
				$dom.depdate.month.append(optionElem)
			})
		}

		/** 出発日 年変更イベント */
		$dom.depdate.year.on('change', (evt) => {
			eventStop(evt)
			const year = $(evt.currentTarget).nvl()
			const month = $dom.depdate.month.nvl()

			const yyyy = _.padStart(year, 4, '0')
			const mm = _.padStart(month, 2, '0')

			const yyyymm = `${yyyy}${mm}`

			const mo = moment(`${yyyymm}01`, 'YYYYMMDD')

			updateDateValidation({
				year: toInt(yyyy),
				month: toInt(mm),
			})

			runInAction('出発日', () => {
				SearchDomState.dep_yymm = `${yyyymm}`
			})
		})

		/** 出発日 月変更イベント */
		$dom.depdate.month.on('change', (evt) => {
			eventStop(evt)
			const year = $dom.depdate.year.nvl()
			const month = $(evt.currentTarget).nvl()

			const yyyy = _.padStart(year, 4, '0')
			const mm = _.padStart(month, 2, '0')

			const yyyymm = `${yyyy}${mm}`

			const mo = moment(`${yyyymm}01`, 'YYYYMMDD')

			runInAction('出発日', () => {
				if (mo.isValid()) SearchDomState.dep_yymm = `${yyyy}${mm}`
				else SearchDomState.dep_yymm = ``
			})
		})

		/** 出発日 日変更イベント */
		$dom.depdate.day.on('change', (evt) => {
			eventStop(evt)
			const day = $(evt.currentTarget).nvl()

			const dd = _.padStart(day, 2, '0')

			runInAction('出発日', () => {
				SearchDomState.dep_dd = dd == '00' ? '' : dd
			})
		})

		/** 日付ピッカー設定 */
		if (0 < $dom.depdate.picker.length) {
			/** Pikadayのベースとなるinput要素 */
			const $inputDate = $(`<input type="hidden" disabled>`)

			/** DOMに追加しておく */
			$dom.depdate.picker.after($inputDate)

			/** @type {Pikaday.PikadayOptions} pikadatオプション */
			const pikaOption = {
				field: $inputDate.get(0),
				trigger: $dom.depdate.picker.get(0),
				theme: 'tabix-pika',
				setDefaultDate: false,
				yearSuffix: '年',
				showMonthAfterYear: true, //タイトルは年・月の順番
				showDaysInNextAndPreviousMonths: true, //翌月または前月のカレンダーグリッドの日をレンダリング
				enableSelectionDaysInNextAndPreviousMonths: true, //翌月または前月の日付を選択できるように
				firstDay: 0, // 0:日 1:月 2:火 ...etc
				yearRange: [moRange.start.year(), moRange.end.year()],
				minDate: moRange.start.toDate(),
				maxDate: moRange.end.toDate(),
				onSelect: (date) => {
					const modate = moment(date)
					runInAction('カレンダーピッカー選択', () => {
						SearchDomState.dep_yymm = modate.format('YYYYMM')
						SearchDomState.dep_dd = modate.format('DD')
					})
					return true
				},
				i18n: {
					previousMonth: '前月',
					nextMonth: '翌月',
					months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
					weekdays: ['日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'],
					weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
				},
			}
			const mo = moment(`${SearchDomState.dep_yymm}${nvl(SearchDomState.dep_dd, '01')}`, 'YYYYMMDD')
			// console.info(mo)
			if (mo.isValid()) {
				if (nvl(SearchDomState.dep_dd)) {
					Object.assign(pikaOption, {
						setDefaultDate: true,
						defaultDate: mo.toDate(),
					})
					/** Pikadayのインスタンス生成 */
					const pika = (depDatePicker = new Pikaday(pikaOption))
				} else {
					/** Pikadayのインスタンス生成 */
					Object.assign(pikaOption, {
						setDefaultDate: false,
					})
					const pika = (depDatePicker = new Pikaday(pikaOption))
					if (SearchDomState.dep_yymm) {
						const yy = toInt(_.padStart(SearchDomState.dep_yymm.substr(0, 4), 4, '0'))
						const mm = toInt(_.padStart(SearchDomState.dep_yymm.substr(4, 2), 2, '0')) - 1
						pika.gotoDate(new Date(yy, mm))
					}
				}
			}

			// console.warn(pika)
		}

		return data
	}

	/** 検索メニューの各種UIアクションを有効化 */
	function enableMenuUIAction() {
		/** 検索ボタンクリックイベント登録 */
		$dom.searchBtn.on(
			'click',
			actionGuard(() => {
				/** 現在のURLパラメータを基本の値とする */
				const myState = (() => {
					const info = urlInfo()
					/** クエリオブジェクトから検索状態に適用するオブジェクトに変換 */
					const urlState = convertToState(info.param)

					return _.merge(SearchState.new(), urlState, toJS(SearchDomState))
				})()

				// console.warn('myState', _.cloneDeep(myState) )

				/** 送信データ収集 */
				myState.page = 1

				/** 送信データはすでに toJS(SearchDomState)で値が格納されているのでコメントアウト */
				// console.warn( `myState.searchkeyword`, myState.searchkeyword )
				// myState.searchkeyword = _.compact( SearchDomState.searchkeyword.slice() )
				// myState.roompax = SearchDomState.roompax
				// myState.term = SearchDomState.term
				// myState.minprice = SearchDomState.minprice
				// myState.maxprice = SearchDomState.maxprice
				// myState.tcflag = SearchDomState.tcflag

				/** 出発地 */
				// myState.dep1 = SearchDomState.dep1
				// myState.dep2 = SearchDomState.dep2
				// myState.dep3 = SearchDomState.dep3
				// myState.dep4 = SearchDomState.dep4
				// myState.dep5 = SearchDomState.dep5
				// myState.dep6 = SearchDomState.dep6

				/** 目的地 */
				// myState.homen1 = SearchDomState.homen1
				// myState.homen2 = SearchDomState.homen2
				// myState.homen3 = SearchDomState.homen3
				// myState.homen4 = SearchDomState.homen4
				// myState.homen5 = SearchDomState.homen5
				// myState.homen6 = SearchDomState.homen6
				// myState.homen7 = SearchDomState.homen7
				// myState.homen8 = SearchDomState.homen8
				// myState.homen9 = SearchDomState.homen9
				// myState.homen_and = SearchDomState.homen_and

				/** 宿泊施設 */
				// myState.hotel = SearchDomState.hotel.slice()

				/** こだわり条件(and) */
				// myState.choice = SearchDomState.choice.slice()

				// myState.transfer = SearchDomState.transfer.slice()
				// myState.transport = SearchDomState.transport.slice()
				// myState.branch_cd = SearchDomState.branch_cd.slice()

				/** 出発日設定 */
				// myState.dep_yymm = SearchDomState.dep_yymm
				// myState.dep_dd = SearchDomState.dep_dd

				/** 実行 */
				if (!formValidation()) return //!EXIT

				/**
				 * hiddenを収集したオブジェクトを作成
				 * @description input hiddenをリンク先に反映する(menu.jsのパラメータを優先)
				 * @see https://eyetech.backlog.com/view/USER_REQUEST_PROD-5343#comment-22126072
				 */
				const hiddens = _($('input[type="hidden"]', $dom.form).toArray())
					.map((elem) => $(elem))
					.filter(($elem) => $elem.is(':disabled') === false)
					.reduce((acc, $elem) => {
						/**  */
						const pname = $elem.attr('name')
						const value = $elem.val()
						const key = pname.toUpperCase()

						/** hiden要素はParamKeyに登録しておく */
						if (!_.has(ParamKey, key)) _.set(ParamKey, key, pname)

						return Object.assign(acc, {[key]: value})
					}, {})

				/** hiddenを収集したオブジェクトをマージ */
				_.merge(myState, hiddens)

				// console.info( `myState`, _.cloneDeep(myState) )

				/** 送信データを状態オブジェと合成し、検索URL作成 */
				const pathURL = createSearchURLBinded(myState)
				// console.warn(myState, pathURL)

				/** 画面遷移モードの場合 */
				if (opt.goto) {
					App.permanentSession.setItem(KEYS.SEARCH_STATE, myState)
					App.permanentSession.setItem(KEYS.SEARCH_URL, pathURL)

					/** 画面遷移させる */
					location.href = pathURL
					return //!EXIT
				}

				/** 検索イベントを発行 */
				event.emit(EVENTS.SEARCH, pathURL)
			}),
		)

		/** 出発地追加ボタンイベント登録 */
		$dom.dep.openBtn.on(
			'click',
			runInActionGuard('出発地追加ボタン', () => {
				SearchDomState.tmp_dep3 = SearchDomState.dep3
				SearchDomState.tmp_dep4 = SearchDomState.dep4
				SearchDomState.tmp_dep5 = SearchDomState.dep5
				SearchDomState.tmp_dep6 = SearchDomState.dep6

				/** モーダル画面表示 */
				ModalQueue.regist($dom.dep.modal).open()
			}),
		)

		/** 出発地指定するボタンイベント登録 */
		$dom.dep.applyBtn.on(
			'click',
			runInActionGuard(
				'出発地指定するボタン',
				(evt) => {
					SearchDomState.dep3 = SearchDomState.tmp_dep3
					SearchDomState.dep4 = SearchDomState.tmp_dep4
					SearchDomState.dep5 = SearchDomState.tmp_dep5
					SearchDomState.dep6 = SearchDomState.tmp_dep6
				},
				{stop: false},
			),
		)

		/** 目的地追加ボタンイベント登録 */
		$dom.homen.openBtn.on(
			'click',
			runInActionGuard('目的地追加ボタン', () => {
				SearchDomState.tmp_homen4 = SearchDomState.homen4
				SearchDomState.tmp_homen5 = SearchDomState.homen5
				SearchDomState.tmp_homen6 = SearchDomState.homen6
				SearchDomState.tmp_homen7 = SearchDomState.homen7
				SearchDomState.tmp_homen8 = SearchDomState.homen8
				SearchDomState.tmp_homen9 = SearchDomState.homen9
				/** モーダル画面表示 */
				ModalQueue.regist($dom.homen.modal).open()
			}),
		)

		/** 目的地指定するボタンイベント登録 */
		$dom.homen.applyBtn.on(
			'click',
			runInActionGuard(
				'目的地指定するボタン',
				() => {
					SearchDomState.homen4 = SearchDomState.tmp_homen4
					SearchDomState.homen5 = SearchDomState.tmp_homen5
					SearchDomState.homen6 = SearchDomState.tmp_homen6
					SearchDomState.homen7 = SearchDomState.tmp_homen7
					SearchDomState.homen8 = SearchDomState.tmp_homen8
					SearchDomState.homen9 = SearchDomState.tmp_homen9
				},
				{stop: false},
			),
		)

		/** 宿泊施設オープンイベント登録 */
		$dom.hotel.openBtn.eventFirst('click', async (evt) => {
			/** 最低限必要な方面情報を収集 */
			const homenData = [SearchDomState.homen1, SearchDomState.homen4, SearchDomState.homen7]

			/** nullチェック */
			if (_.compact(homenData).length === 0) {
				/** nullだった場合、アラートで説明通知 */
				eventStop(evt)

				//@ts-ignore
				const notice = new PNotify.alert(
					Object.assign(AlertOptions, {
						title: 'ご確認',
						text: '目的地を選択してください',
					}),
				)

				/** OKボタンでフォーカス移動 */
				notice.on(EVENTS.CONFIRM, function () {
					const $scrollTarget = $('.SearchMenu .Des')
					const flashElem = $('.Des .CustomSelect').get(0)
					/** 目的地にスクロール */
					const animeIns = anime
						.timeline({
							complete: () => {
								$dom.homen.homen1.focus()
							},
						})
						.add({
							targets: scrollElem,
							scrollTop: $scrollTarget.offset().top,
							duration: 380,
							easing: 'easeOutQuart',
						})

					/** エリアを点滅 */
					Range(1, 3)
						.toArray()
						.forEach(() => {
							animeIns
								.add({
									targets: flashElem,
									'border-color': '#D91B20',
									duration: 251,
								})
								.add({
									targets: flashElem,
									'border-color': '#E6E5E3',
									duration: 151,
								})
						})
					// ModalQueue.regist($dom.homen.modal).regist($dom.hotel.modal).open()
				})

				return false //!EXIT
			}

			/** モーダル画面表示 */
			ModalQueue.regist($dom.hotel.modal).open()
		})

		/** 宿泊施設指定イベント */
		$dom.hotel.applyBtn.on(
			'click',
			runInActionGuard(
				'宿泊施設指定ボタン',
				() => {
					/** @type {string[]} */
					const hotelCodes = _.chain($('input:checked', $dom.hotel.listArea).toArray())
						.map((elem) => {
							return $(elem).nvl()
						})
						.value()
					// console.log('hotelCodes')
					// console.log(hotelCodes)
					SearchDomState.hotel = hotelCodes
				},
				{stop: false},
			),
		)

		/** こだわり条件モーダル画面オープンイベント */
		$dom.choice.openBtn.on(
			'click',
			actionGuard(() => {
				/** モーダル画面表示 */
				ModalQueue.regist($dom.choice.modal).open()
			}),
		)

		/** こだわり条件指定イベント */
		$dom.choice.applyBtn.on(
			'click',
			runInActionGuard(
				'こだわり条件指定するボタン',
				() => {
					const _items = _.chain($('input:checked', $dom.choice.listArea).toArray())

					/** @type {string[]} */
					const choiceCodes = _items
						.map((elem) => {
							return $(elem).nvl()
						})
						.value()
					/** 状態オブジェクトに格納 */
					SearchDomState.choice = choiceCodes
				},
				{stop: false},
			),
		)

		/** 交通機関モーダル画面オープンイベント */
		$dom.transfer.openBtn.on(
			'click',
			actionGuard(() => {
				/** モーダル画面表示 */
				ModalQueue.regist($dom.transfer.modal).open()
			}),
		)

		/** 交通機関指定イベント */
		$dom.transfer.applyBtn.on(
			'click',
			runInActionGuard(
				'交通機関を指定するボタン',
				() => {
					const transferValues = _.chain($('input:checked', $dom.transfer.listArea.find('dt')).toArray())
						.map((elem) => {
							return `${$(elem).nvl()}`
						})
						.value()

					const transportValues = _.chain($('input:checked', $dom.transfer.listArea.find('dd')).toArray())
						.map((elem) => {
							return `${$(elem).nvl()}`
						})
						.value()

					/** 状態オブジェクトに格納 */
					Object.assign(SearchDomState, {
						transfer: transferValues,
						transport: transportValues,
					})
				},
				{stop: false},
			),
		)

		/** リセットボタン */
		$dom.resetBtn.on(
			'click',
			runInActionGuard(
				'リセットボタン押下',
				() => {
					/** リセット用デフォルトオブジェクト取得 */
					const resetState = SearchState.new()
					/** 営業所だけは設定残す */
					resetState.branch_cd = SearchDomState.branch_cd
					deepUnset(resetState, 'new')
					/** 指定キーを除去 */
					Object.assign(
						SearchDomState,
						_.omit(resetState, [
							'hcd',
							'agent',
							'pamphletcd',
							'dep_grp',
							'hmn_grp',
							'cho_grp',
							'trf_grp',
							'tem_grp',
							'ysn_grp',
							'pax_grp',
							'branch_cd',
							'page',
							'size',
							'sort',
						]),
					)
				},
				{stop: false},
			),
		)

		$dom.homen.radio.on('change', (evt) => {
			runInAction('方面 and or 条件変更', () => {
				SearchDomState.homen_and = $(evt.currentTarget).nvl()
			})
		})

		$dom.tc.on('change', (evt) => {
			// eventStop(evt)
			runInAction('添乗員セレクタ変更', () => {
				SearchDomState.tcflag = $(evt.currentTarget).nvl()
			})
		})

		$dom.term.on('change', (evt) => {
			// eventStop(evt)
			runInAction('旅行期間セレクタ変更', () => {
				SearchDomState.term = $(evt.currentTarget).nvl()
			})
		})

		$dom.pax.on('change', (evt) => {
			// eventStop(evt)
			runInAction('利用人数セレクタ変更', () => {
				SearchDomState.roompax = $(evt.currentTarget).nvl()
			})
		})

		$dom.price.min.on('change', (evt) => {
			// eventStop(evt)
			runInAction('下限予算セレクタ変更', () => {
				SearchDomState.minprice = $(evt.currentTarget).nvl()
			})
		})

		$dom.price.max.on('change', (evt) => {
			// eventStop(evt)
			runInAction('上限予算セレクタ変更', () => {
				SearchDomState.maxprice = $(evt.currentTarget).nvl()
			})
		})
	}

	/**
	 * 検索用マスターデータ取得
	 * @param {SearchMenuOption} [options] 検索メニュー制御オプション
	 */
	function getMaster(options) {
		deepUnset(options, 'new')
		const paramData = convertToParam(options)

		validSearchMenuParams(paramData)
		return async function () {
			/** @type {MSearchMenu.Items} */
			const resData =
				_.size(SearchMaster) > 0
					? /** マスターデータがあれば再利用 */
					  SearchMaster
					: /** マスターデータがなければajaxで取得 */
					  await Ajax.load({
							url: `${API_PATH}/v1/master/searchmenu`,
							method: `GET`,
							dataType: 'json',
							data: paramData,
					  }).then(fetchItem)

			return resData
		}
	}

	/**
	 * 検索用マスターデータ設定
	 * @param {MSearchMenu.Items} data
	 */
	function setMaster(data) {
		_.merge(SearchMaster, data)
		// console.warn('マスターデータ', SearchMaster)

		const {budget, dep, homen, pax, term, transfer, choice} = SearchMaster

		runInAction('setMaster', () => {
			SearchDomState.paxMenu = pax
			SearchDomState.termMenu = term
			SearchDomState.minpriceMenu = budget
			SearchDomState.maxpriceMenu = budget
		})

		setDepMenu(dep)
		setHomenMenu(homen)
		setTransferMenu(transfer)
		setChoiceMenu(choice)
		event.emit(EVENTS.MASTER_READY)
		return data
	}

	/**
	 * 出発地マスタデータ構築
	 * @param {MSearchMenu.Dep[]} data
	 */
	function setDepMenu(data) {
		/** 状態オブジェに渡すデータを構築 */
		const area1 = _.chain(data)
			.map((item) => {
				return {
					code: item.area1,
					name: item.area1name,
					display: true,
				}
			})
			.uniqWith(_.isEqual)
			.value()

		const area2 = _.chain(data)
			.map((item) => {
				return {
					parent: item.area1,
					code: item.area2,
					name: item.area2name,
					display: false,
				}
			})
			.value()

		/** 状態オブジェにデータセット */
		runInAction('setDepMenu 1', () => {
			SearchDomState.dep1Menu = area1
			SearchDomState.dep2Menu = area2
		})

		runInAction('setDepMenu 2', () => {
			SearchDomState.dep3Menu = area1
			SearchDomState.dep4Menu = area2
		})

		runInAction('setDepMenu 3', () => {
			SearchDomState.dep5Menu = area1
			SearchDomState.dep6Menu = area2
		})
	}

	/**
	 *
	 *
	 * @description `pretty-checkbox`の力を借ります
	 * @param {MSearchMenu.Transfer[]} data
	 */
	function setTransferMenu(data) {
		const baseTag = TXT`<dl>
							|	<dt>
							|		<span class="CustomCheckobx pretty p-default">
							|			<input type="checkbox" id="" value="">
							|			<label for=""></label>
							|		</span>
							|	</dt>
							|	<dd>
							|		<ul></ul>
							|	</dd>
							|</dl>
							|`

		const listTag = TXT`<li>
							|	<span class="CustomCheckobx pretty p-default">
							|		<input type="checkbox" id="" value="">
							|		<label for=""></label>
							|	</span>
							|</li>
							|`

		_.chain(data)
			/** Mapは追加順で順序を保持 */
			.groupBy((item) => `${item.sort1}:${item.transfer1}`)
			.tap(() => $dom.transfer.listArea.empty())
			.map((group) => {
				/** ソート情報はもう不要なので破棄*/
				// console.log(`${code}`, group)
				// code = _(code).chain().split(':').last().value();

				return _(group)
					.chain()
					.reduce(($baseTag, item, idx) => {
						/** 先頭データは交通手段のタグを構築 */
						if (idx === 0) {
							const id = `searchmenu_transfer_${item.transfer1}`
							$('dt input[type="checkbox"]', $baseTag)
								.attr('id', id)
								.val(item.transfer1)
								// .on( 'click', evt =>{
								// 	modalCheckboxStateAction( $(evt.currentTarget).closest('dl') )
								// } )
								.next('label')
								.attr('for', id)
								.text(item.transfer1name)
						}

						/** キャリア設定 */
						{
							const id = `searchmenu_transfer_${item.transfer1}_${idx}`
							const $listTag = $(listTag)
							$('input[type="checkbox"]', $listTag)
								.attr('id', id)
								.val(item.transfer2)
								.next('label')
								.attr('for', id)
								.text(item.transfer2name)

							/** 追加 */
							$baseTag.find('dd>ul').append($listTag)
						}

						return $baseTag
					}, $(baseTag))
					.value()
			})
			.each(($dl) => $dom.transfer.listArea.append($dl))
			.tap(($dlList) => {
				/** チェック済みアイテムの対応 交通手段 */
				applyCheckboxState($dom.transfer.listArea.find('dt'), SearchDomState.transfer)
				/** チェック済みアイテムの対応 輸送キャリア */
				applyCheckboxState($dom.transfer.listArea.find('dd'), SearchDomState.transport)
			})
			// .each( $dl =>{
			// 	/** 親となるとチェックボックスの状態を見て、子のチェックボックスを制御 */
			// 	modalCheckboxStateAction( $dl )
			// } )
			.commit()
	}

	/**
	 *
	 * @description `pretty-checkbox`の力を借ります
	 * @param {MSearchMenu.Choice[]} data
	 */
	function setChoiceMenu(data) {
		const baseTag = TXT`<dl>
							|	<dt>
							|		<label></label>
							|	</dt>
							|	<dd>
							|		<ul></ul>
							|	</dd>
							|</dl>
							|`

		const listTag = TXT`<li>
							|	<span class="CustomCheckobx pretty p-default">
							|		<input type="checkbox" id="" value="">
							|		<label for=""></label>
							|	</span>
							|</li>
							|`

		_.chain(data)
			.groupBy((item) => `${item.sort1}:${item.choice1}`)
			.tap(() => $dom.choice.listArea.empty())
			.map((group) => {
				return _.reduce(
					group,
					($baseTag, item, idx) => {
						/** 先頭データはラベルタグを構築 */
						if (idx === 0) {
							const id = `searchmenu_choice_${item.choice1}`
							$('dt label', $baseTag).attr('id', id).text(item.choice1name)
						}

						/** キャリア設定 */
						{
							const id = `searchmenu_choice_${item.choice1}_${idx}`
							const $listTag = $(listTag)
							$('input[type="checkbox"]', $listTag)
								.attr('id', id)
								.data('item', item)
								.val(item.choice2)
								.next('label')
								.attr('for', id)
								.text(item.choice2name)

							/** 追加 */
							$baseTag.find('dd>ul').append($listTag)
						}

						return $baseTag
					},
					$(baseTag),
				)
			})
			.each(($dl) => {
				$dom.choice.listArea.append($dl)
			})
			//.tap( console.warn )
			.tap(($dlList) => {
				/** チェック済みアイテムの対応 交通手段 */
				applyCheckboxState($dom.choice.listArea.find('dd'), SearchDomState.choice)
			})
			// .each( $dl =>{
			// 	/** 親となるとチェックボックスの状態を見て、子のチェックボックスを制御 */
			// 	modalCheckboxStateAction( $dl )
			// } )
			.commit()
	}

	/**
	 * 出発地マスタデータ構築
	 * @param {MSearchMenu.Homen[]} data
	 */
	function setHomenMenu(data) {
		/** 状態オブジェに渡すデータを構築 */
		/** @type {AreaType1[]} */
		const area1 = _.chain(data)
			.map((item) => {
				return {
					code: item.area1,
					name: item.area1name,
					display: true,
				}
			})
			.uniqWith(_.isEqual)
			.value()

		/** @type {AreaType2[]} */
		const area2 = _.chain(data)
			.map((item) => {
				return {
					parent: item.area1,
					code: item.area2,
					name: item.area2name,
					display: false,
				}
			})
			.uniqWith(_.isEqual)
			.value()

		/** @type {AreaType3[]} */
		const area3 = _.chain(data)
			.map((item) => {
				return {
					root: item.area1,
					parent: item.area2,
					code: item.area3,
					name: item.area3name,
					display: false,
				}
			})
			.value()

		/** 状態オブジェにデータセット */
		runInAction('setHomenMenu 1', () => {
			SearchDomState.homen1Menu = area1
			SearchDomState.homen2Menu = area2
			SearchDomState.homen3Menu = area3
		})

		runInAction('setHomenMenu 2', () => {
			SearchDomState.homen4Menu = area1
			SearchDomState.homen5Menu = area2
			SearchDomState.homen6Menu = area3
		})

		runInAction('setHomenMenu 3', () => {
			SearchDomState.homen7Menu = area1
			SearchDomState.homen8Menu = area2
			SearchDomState.homen9Menu = area3
		})
	}
}

/** 初回のURLパラメータ適用後にアクション登録 */
const lazyActionRegist = function () {
	Array.prototype.push.apply(ActionList, depMenuLazyActions)
	Array.prototype.push.apply(ActionList, homenMenuLazyActions)
}

/** 開発時にコンソールから触りたいヤツをglobalに置く(globalに置くと遅くなるので本番ではglobalに置かない) */
if (App.isDevelop) {
	registToGlobal({
		$dom,
		SearchDomState,
		fx,
		anime,
		ModalQueue,
	})
}

export {
	KEYS,
	EVENTS,
	event,
	boot,
	searchMenu,
	convertToParam,
	convertToState,
	createSearchURL,
	lazyActionRegist,
	validSearchMenuParams,
	validSearchParams,
}

/** @typedef {Partial<import('./store').SearchState>} SearchState */
/** @typedef {Partial<import('./store').SearchDomState>} SearchDomState */
/** @typedef {Partial<import('./store').SearchMenuOption>} SearchMenuOption */
